module.exports = {"username":"demo.analis_bc","id":"39","group":"beacukai","status":"enabled","detil":{"nama":"Demo Analis BC","nip":"454545125151454545","pangkat":"Penata Muda Tk.i - III/b","kode_eselon2":"005000","eselon2":"Direktorat P2","kode_eselon3":null,"eselon3":null,"kantor":"Direktorat P2","kantor_id":"005000","kantor_level":"eselon2"},"roleInfo":{"siroleg":[{"role":"siroleg.bc.analis","role_name":"Analis Beacukai","name":"siroleg","domains":"siroleg-dist.test","description":"Siroleg","icon":""}]}}


//////////////////
// WEBPACK FOOTER
// ./src/router/fake_tokens/token_analis.json
// module id = CkaY
// module chunks = 10